import { ErrorBoundary } from 'react-error-boundary';
import { Logo } from './Logo';
import { NavigationBar } from './NavigationBar';
import { StatusBar } from './StatusBar';

export function MainHeader() {
  return (
    <div
      id="NoHeader"
      className="tlw-h-16 tlw-flex tlw-px-4 tlw-justify-between tlw-items-center tlw-bg-white tlw-border-b tlw-border-b-sec-sup-light tlw-box-border lg:tlw-z-1 lg:tlw-relative lg:tlw-px-10"
    >
      {/* Logo */}
      <ErrorBoundary fallback={<div>Logo</div>}>
        <Logo />
      </ErrorBoundary>

      {/* 導航欄 */}
      <ErrorBoundary fallback={<nav>NavigationBar</nav>}>
        <NavigationBar />
      </ErrorBoundary>

      {/* 狀態欄  */}
      <ErrorBoundary fallback={<div>StatusBar</div>}>
        <StatusBar />
      </ErrorBoundary>
    </div>
  );
}
